export default __webpack_public_path__ + "static/media/icon_data_delete_btn.5322f55b.svg";